/**
 * Normalizes text for use in tracking attributes (data-* attributes)
 * Converts to lowercase, replaces special characters with spaces,
 * then replaces multiple spaces with single dashes
 */
export const normalizeForTracking = (text: string): string => {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, '-')
        .replace(/^-+|-+$/g, '');
};

/**
 * Creates a tracking value with a prefix and normalized text
 * Example: createTrackingValue('career-category', 'Agriculture & Horticulture')
 * returns 'career-category-agriculture-horticulture'
 */
export const createTrackingValue = (prefix: string, value: string): string => {
    return `${prefix}-${normalizeForTracking(value)}`;
};
